var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('router-link',{staticClass:"btn-add",attrs:{"to":{ name:_vm.route }}},[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"btn-add"},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }